import styled from 'styled-components';
import { Card, Tag } from 'antd';

export const TagResponsiva = styled(Tag)`
  display: inline;
  text-overflow: ellipsis;
`;

export const BlocoJson = styled(Card)`
  background: lightyellow;
  font-size: 12px;
  max-height: 50vh;
  overflow-y: auto;
  .ant-card-body {
    padding: 20px;
  }
`;

export const ChaveJson = styled.p`
  margin-left: 10px;
  margin-bottom: 5px;
`;

export const Status = styled.div`
  font-size: 13px;
  margin-top: 30px;
  margin-bottom: 20px;
`;
